
jQuery(document).ready(function(){

    // Click function for the DKK format switcher
   /* setTimeout(function(){
        jQuery('.BOLD-mc-picker ul.currencyList li:first-child').addClass('clicker');
        console.log('clicker class');
        jQuery('.BOLD-mc-picker.multi .clicker').click(function(){
            console.log('hej');
            jQuery('span.money').hide();
              jQuery('span.money').each(function(){
                if(jQuery('.currentCurrency .name').text() == 'DKK' ){
                    setTimeout(function(){
                    var textString = jQuery(this).text();
                    var res = textString.split('.');
            
                        console.log(textString);
                        console.log(res[0]);
                        console.log(res[1]);
                        
                        changeValutaFormat();
                        jQuery('span.money').show();
                    }, 100);
                }
            
            });
        });
    }, 1000);
  
    // Function that checks format for DKK valuta and changes it
    function changeValutaFormat(){
        console.log('test');
        if(jQuery('.currentCurrency .name').text() == 'DKK' ){
            jQuery('span.money').each(function(){
                var textString = jQuery(this).text();
                var replace = textString.replace('kr.', '');
                //console.log(replace);
                //var res = textString.split('kr.');
                if( textString == replace){
                    console.log('Not changing text');
                }else{
                    jQuery(this).text(replace + ' DKK');
                }
            });
        }
    }
        
    // Makes a loop and runs changeValutaFormat every second for 3 seconds
    var n = 0;
    var currencyInterval = setInterval(testCurrency, 1000);

    function testCurrency(){
        jQuery('span.money').hide();
        n++;
        console.log('Round ' + n);
        changeValutaFormat();
        if(n == 4){
            console.log('DONE TESTING');
            stopInterval();
            jQuery('span.money').show();
        }
    }

    // Function to stop the loop
    function stopInterval() {
        clearInterval(currencyInterval);
    }

    if(jQuery(window).width() < 768 ){
        var valutaChanger = jQuery('span.BOLD-mc-picker-mnt');
        jQuery(valutaChanger).insertAfter('ul.mobile-nav__social');
        jQuery(valutaChanger).css({'top': '0', "left": "0"});
        jQuery('.BOLD-mc-picker > .currencyList').css('left', "23.2%");
    }*/
});
